import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { GiaContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/GiaContributionInstruction";
import { IsaContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/IsaContributionInstruction";
import { SubAccountAmendmentInstructionClient } from "../../../../../../Wrap/Api/Apply/SubAccountAmendmentInstruction";
import { WhatIfToolCopyClient } from "../../../../../../Wrap/Api/Apply/WhatIfToolCopy";
import { WhatIfToolInstructionClient } from "../../../../../../Wrap/Api/Apply/WhatIfToolInstruction";
import { ProcessType } from "../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { SubAccountTypeHelper } from "../../Common/Helpers/SubAccountTypeHelper";
import { WhatIfToolDisaptcher } from "../Store/Variable";

export class WhatIfAction {
    public static getInstruction(
        id: string,
        hierarchyId: string,
        subAccountHierarchyId: string,
        clientId: number,
        productType: SubAccountType,
        batchId: number
    ): void {
        if (SubAccountTypeHelper.isPP(productType)) {
            const giaContributionInstruction = new GiaContributionInstructionClient();
            this.getOrCreateInstruction(
                giaContributionInstruction,
                id,
                hierarchyId,
                subAccountHierarchyId,
                clientId,
                batchId
            );
        } else if (SubAccountTypeHelper.isIsa(productType)) {
            const isaContributionInstruction = new IsaContributionInstructionClient();
            this.getOrCreateInstruction(
                isaContributionInstruction,
                id,
                hierarchyId,
                subAccountHierarchyId,
                clientId,
                batchId
            );
        }
    }

    public static saveInstruction(from, data: any, type, callback?: (data) => void): void {
        if (SubAccountTypeHelper.isPP(type)) {
            const giaContributionInstruction = new GiaContributionInstructionClient();
            const promise = giaContributionInstruction.put(data, "");
            this.updateWhatiIfInstructionStore(promise, callback);
        } else if (SubAccountTypeHelper.isIsa(type)) {
            const client = new IsaContributionInstructionClient();
            const promise = client.put(data);
            this.updateWhatiIfInstructionStore(promise, callback);
        } else {
            callback([]);
        }
    }

    public static deleteInstruction(id, callback?: VoidFunction): void {
        const client = new SubAccountAmendmentInstructionClient();
        const promise = client.delete(id);
        promise.onSuccess((result) => {
            if (callback) {callback();}
        });
    }

    private static getOrCreateInstruction(
        client: IsaContributionInstructionClient | GiaContributionInstructionClient,
        id,
        hierarchyId,
        subAccountHierarchyId,
        clientId,
        batchId
    ) {
        if (!CommonHelper.isNullOrEmpty(id)) {
            // Have instructionId
            const promise = client.get(id, clientId, "", batchId);
            this.updateWhatiIfInstructionStore(promise);
        } else {
            // Create new instruction
            const promise = client.post(subAccountHierarchyId, hierarchyId, ProcessType.WhatIfTool);
            promise.onSuccess((result) => {
                const instructionId = result.Result;
                const model = client.get(instructionId, clientId, "", batchId);
                this.updateWhatiIfInstructionStore(model);
            });

            promise.onError((err) => {
                WhatIfToolDisaptcher.dispatch({
                    actionType: ActionType.Error,
                    payload: err,
                });
            });
        }
    }

    private static updateWhatiIfInstructionStore(promise: any, callback?: (data) => void) {
        promise.onSuccess((result) => {
            WhatIfToolDisaptcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
            if (result.Errors != null && result.Errors.length > 0) {
                callback(result.Errors.map((ele) => ele.UserMessage));
            } else {
                callback(result);
            }
        });

        promise.onError((err) => {
            WhatIfToolDisaptcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static getPrepopulateData(
        subAccountHierarchyId: string,
        headHierarchyId: string,
        batchId: number,
        callback
    ) {
        const client = new WhatIfToolInstructionClient();
        const promise = client.get(subAccountHierarchyId, headHierarchyId, batchId);
        promise.onSuccess((data) => {
            callback(data);
        });
    }

    public static submitInstruction(instructionId: string, callback) {
        const client = new WhatIfToolInstructionClient();
        const promise = client.put(instructionId);
        promise.onSuccess((data) => {
            callback(data);
        });
    }

    public static copyInstruction(instructionId: string, subHierarchyId: string, type: SubAccountType, callback) {
        const client = new WhatIfToolCopyClient();
        const promise = client.put(instructionId, subHierarchyId, type);
        promise.onSuccess((data) => {
            callback(data);
        });
    }
}
